//

import { useEffect, useState } from "react";

function formatDate(dt: Date) {
  const fill = (nr: number) => {
    let s = `${nr}`;
    if (s.length < 2) {
      return `0${s}`;
    }
    return s;
  };
  return `${dt.getFullYear()}-${fill(dt.getUTCMonth() + 1)}-${fill(
    dt.getUTCDate()
  )}`;
}

interface DatePickerProps {
  date: Date;
  min?: Date;
  max?: Date;
  onChange: (date: Date) => void;
}

const DatePicker = (props: DatePickerProps) => {
  const [min, setMin] = useState<string>("");
  const [max, setMax] = useState<string>("");

  const onChangeDate = (ev: any) => {
    const val = ev.target.valueAsNumber;
    const newDate = new Date(val);
    props.onChange(newDate);
  };

  useEffect(() => {
    if (props.min)
      setMin(formatDate(props.min));
  }, [props.min]);

  useEffect(() => {
    if (props.max)
      setMax(formatDate(props.max));
  }, [props.max]);

  return (
    <input
      className="dateinput"
      type="date"
      name="Day"
      value={formatDate(props.date)}
      onChange={onChangeDate}
      min={min}
      max={max}
    ></input>
  );
};

export default DatePicker;
